import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { ConfigurationFile } from 'containers/misc'
import { MaterialModal } from 'components/layout'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { apiConfiguration } from 'helpers/decorators/api'
import { form } from '../../../helpers/decorators'

const DOCUMENT_CONFIG_KEYS = [
  CONFIGURATION_KEYS.userGuideParticipant.id,
  CONFIGURATION_KEYS.userGuideWebParticipant.id,
  CONFIGURATION_KEYS.termsAndConditions.id
]

@form({
  form: 'privacyPolicyForm',
  disableHook: true
})
@apiConfiguration()
class UserGuideModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    award: PropTypes.object,
    hasPolicy: PropTypes.bool,
    policyText: PropTypes.string,
    initialize:PropTypes.func,
    onGetConfigurationValues: PropTypes.func
  }

  componentDidMount() {
    this.props.initialize({ policyText: this.props.policyText })
    this.props.onGetConfigurationValues(DOCUMENT_CONFIG_KEYS, this.getOrganizationId(), true)
  }

  getOrganizationId = () => get(this.props, 'award.organization.id') || 1

  render() {
    const { modalId, award, hasPolicy, policyText } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title="Guides and Policies"
        titleKey="moduleTitle.guides_and_policies"
      >
        <MaterialModal.Content noFooter>
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.userGuideParticipant.id}
            organizationId={get(award, 'organization.id')}
            isPublic
            noFetch
            formattedName={
              <FormattedMessage
                id="label.user_guide_app_participant"
                defaultMessage="User guide - app participant"
              />
            }
          />
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.userGuideWebParticipant.id}
            organizationId={get(award, 'organization.id')}
            isPublic
            noFetch
            formattedName={
              <FormattedMessage
                id="label.user_guide_web_participant"
                defaultMessage="User guide - web participant"
              />
            }
          />
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.termsAndConditions.id}
            organizationId={get(award, 'organization.id')}
            isPublic
            noFetch
            formattedName={
              <FormattedMessage
                id="label.terms_and_conditions"
                defaultMessage="Terms and Conditions"
              />
            }
          />
          {false && <ConfigurationFile
            configKey={CONFIGURATION_KEYS.faqDocuments.id}
            organizationId={get(award, 'organization.id')}
            isPublic
            formattedName={
              <FormattedMessage
                id="label.frequently_asked_questions"
                defaultMessage="Frequently asked questions"
              />
            }
          />}

          {hasPolicy && <div>
            <h4>
          <FormattedMessage
            id="label.privacy_statements"
            defaultMessage="Privacy Statements"
          />
            </h4>
            <form>
              {policyText && <FormattedHTMLMessage
                id="label.empty_privacy_statements"
                defaultMessage={policyText}
              />}
            </form>
          </div>}

        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}

export default UserGuideModal